export enum State {
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
  Gray = 'gray',
  Default = 'gray'
}

export const maintenanceDue = 'maintenance_due'
